import { render, staticRenderFns } from "./judgeQuestions.vue?vue&type=template&id=b2ccd000&scoped=true"
import script from "./judgeQuestions.vue?vue&type=script&lang=js"
export * from "./judgeQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ccd000",
  null
  
)

export default component.exports